import dayjs from 'dayjs';
import { useI18n } from '/@/hooks/web/useI18n';

export const formatDate = (date: string, format = 'YYYY-MM-DD HH:mm:ss') => {
  return date ? dayjs(date).format(format) : '';
};

export const formatCurrentDate = () => dayjs().format('YYYY-MM-DD HH:mm:ss');
export const formatCurrentDate1 = () => dayjs().format('YYYY-MM-DD');

// 今天日期（年-月-日）
export const todayDateString = formatDate(new Date().toISOString().slice(0, 19));

// 去年今日
const todayDate = new Date();
const currentYear = todayDate.getFullYear();
const lastYearDate = new Date(
  currentYear - 1,
  todayDate.getMonth(),
  todayDate.getMonth() === 1 && todayDate.getDate() === 29 ? 29 : 28
);
export const lastYearDateString = formatDate(lastYearDate.toISOString().slice(0, 19));

// 最近一周
export const currentWeekDate = () => dayjs().subtract(7, 'day').format('YYYY-MM-DD HH:mm:ss');
// 最近一月
export const currentMonthDate = () => dayjs().subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss');
// 最近一年
export const startOfLastYear = dayjs().subtract(1, 'year').startOf('year').format('YYYY-MM-DD');
//获取今年的起始日期，包括年月日时分秒
export const startOfThisYear = dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss');
// 本日开始
export const curDayDateStartTime = () => dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss');
// 本日结束
export const curDayDateEndTime = () => dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');

// 本周第一天
export const curWeekDateStartTime = () =>
  dayjs().startOf('week').add(1, 'day').format('YYYY-MM-DD HH:mm:ss');
// 本周最后一天
export const curWeekDateEndTime = () =>
  dayjs().endOf('week').add(1, 'day').format('YYYY-MM-DD HH:mm:ss');
// 本周第一天
export const curYearDateStartTime = () => dayjs().startOf('years').format('YYYY-MM-DD HH:mm:ss');
// 本周最后一天
export const curYearDateEndTime = () => dayjs().endOf('years').format('YYYY-MM-DD HH:mm:ss');

// 上个周第一天
export const lastWeekDateStartTime = () =>
  dayjs().add(-1, 'week').startOf('week').add(1, 'day').format('YYYY-MM-DD HH:mm:ss');
// 上个周最后一天
export const lastWeekDateLastTime = () =>
  dayjs().add(-1, 'week').endOf('week').add(1, 'day').format('YYYY-MM-DD HH:mm:ss');

// 上个月第一天
export const lastMonthDateStartTime = () =>
  dayjs().add(-1, 'month').startOf('month').format('YYYY-MM-DD HH:mm:ss');
// 上个月最后一天
export const lastMonthDateLastTime = () =>
  dayjs().add(-1, 'month').endOf('month').format('YYYY-MM-DD HH:mm:ss');
// 本月第一天
export const curMonthDateStartTime = () => dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss');
// 本月最后一天
export const curMonthDateLastTime = () => dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss');
// 昨天
export const yesterdayStartTime = () =>
  dayjs().subtract(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
export const yesterdayEndTime = () =>
  dayjs().subtract(1, 'day').endOf('day').format('YYYY-MM-DD HH:mm:ss');
// 今天
export const todayStartTime = () => dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss');
export const todayEndTime = () => dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
// 最近一小时
export const curHourStartTime = () => {
  return dayjs().subtract(1, 'hour').format('YYYY-MM-DD HH:mm:ss');
};
const ONE_SECONDS = 1000;
const ONE_MINUTES = ONE_SECONDS * 60;
const ONE_HOUR = ONE_MINUTES * 60;
const ONE_DAY = ONE_HOUR * 24;

export function formatTimeStamp(diff: number) {
  const { t } = useI18n();

  let resStr = '';
  if (diff < ONE_SECONDS) {
    resStr = diff + 'ms';
    // Less than or equal to 59 seconds
  } else if (diff < ONE_MINUTES) {
    resStr = parseInt(diff / ONE_SECONDS) + t('component.time.seconds');
    // More than 59 seconds, less than or equal to 59 minutes and 59 seconds
  } else if (diff >= ONE_MINUTES && diff < ONE_HOUR) {
    resStr = Math.floor(diff / ONE_MINUTES) + t('component.time.minutes');
    // More than 59 minutes and 59 seconds, less than or equal to 23 hours, 59 minutes and 59 seconds
  } else if (diff >= ONE_HOUR && diff < ONE_DAY) {
    resStr = Math.floor(diff / ONE_HOUR) + t('component.time.hours');
    // More than 23 hours, 59 minutes and 59 seconds, less than or equal to 29 days, 59 minutes and 59 seconds
  } else if (diff >= ONE_DAY && diff < 2623860000) {
    resStr = Math.floor(diff / ONE_DAY) + t('component.time.days');
    // More than 29 days, 59 minutes, 59 seconds, less than 364 days, 23 hours, 59 minutes, 59 seconds, and the incoming timestamp is earlier than the current
  }
  return resStr;
}
